import React, { useState, useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from './routes';
import { API_BASE_URL } from './constants';
import OriginalDisplay from './components/Characters/Original/OriginalDisplay';
import CharactersOriginalHeader from './components/Characters/Original/CharactersOriginalHeader';
import CharacterEdit from './components/Admin/Characters/CharacterEdit';
import SEO from './components/shared/SEO';
import LoadingScreen from './components/shared/LoadingScreen';

const CharactersOriginal = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const location = useLocation();

    const isNew = location.pathname === `${ROUTES.CHARACTER}/new`;

    const [characters, setCharacters] = useState([]);
    const [cards, setCards] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Solo necesitamos fetch si estamos en la vista de listado, no en el editor
        if (!id && !isNew) {
            const fetchData = async () => {
                try {
                    setLoading(true);
                    const [charsRes, cardsRes] = await Promise.all([
                        fetch(`${API_BASE_URL}/characters`),
                        fetch(`${API_BASE_URL}/cards`)
                    ]);

                    const charactersData = await charsRes.json();
                    const cardsData = await cardsRes.json();

                    setCharacters(charactersData);
                    setCards(cardsData);
                } catch (error) {
                    console.error('Error fetching data:', error);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        } else {
            setLoading(false); // Ir directo al editor sin cargar listado
        }
    }, [id, isNew]);

    // If we have an ID or we are creating new, show the editor
    if (id || isNew) {
        return <CharacterEdit />;
    }

    if (loading) {
        return <LoadingScreen />;
    }

    // Otherwise show the list
    return (
        <div className="min-h-screen bg-panel-gray pt-20 pb-24">
            <SEO title={t('MetaCharactersOriginal.title')} description={t('MetaCharactersOriginal.description')} />
            <div className="max-w-7xl mx-auto p-6">
                {/* HERO BANNER - STAGE / STARS UPGRADE */}
                <CharactersOriginalHeader />
                <OriginalDisplay characters={characters} cards={cards} />
            </div>
        </div>
    );
};

export default CharactersOriginal;
// Revisado: 2026-02-21 [I18n Scan] - [Meta SEO]
